"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterWith = exports.filter = void 0;

var _isMatch = require("../is-match/is-match");

/**
 * Remove elements that dont match based on custom function
 *
 * @param  {Function}  fn  The function
 *
 * @return {Array}
 *
 * @tag Array
 * @signature (fn: Function) => (source: Array): Array
 */
var filter = function filter(fn) {
  return function (source) {
    var result = [];
    var sourceArray = Array.isArray(source) ? source : [source];

    for (var i = 0, length = sourceArray.length; i < length; i++) {
      if (fn.call(null, sourceArray[i]) === true) {
        result.push(sourceArray[i]);
      }
    }

    return result;
  };
};

exports.filter = filter;

var filterWith = function filterWith(subset) {
  return filter((0, _isMatch.isMatch)(subset));
};

exports.filterWith = filterWith;